// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.notification-for-ie-users[data-v-3d6e5342] {\n    display: block!important;\n}\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
